import Parse from "./parse.service";
import { base64ToBlob } from "../utils";

const Account_managers = Parse.Object.extend("Account_managers");
const Contacts = Parse.Object.extend("Contacts");

import { accountAPI, auth, reminderAPI } from "./index";
import dayjs from "dayjs";

export function fetchUser() {
  return Parse.User.current();
}

// Account Managers

export const accountManagers = async () => {
  const query = new Parse.Query(Account_managers);
  const results = await query.find();
  return results;
};

const downloadReport = async (reportBase64String, fileName) => {
  const blob = base64ToBlob(reportBase64String);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

// Monthly Reports
export const downloadMonthlyReport = async (
  accountId,
  startMonth,
  endMonth,
  type = "pdf"
) => {
  const reportBase64String = await Parse.Cloud.run("getMonthlyreport", {
    id: accountId,
    startMonth:
      startMonth === "lifetime"
        ? "lifetime"
        : { __type: "Date", iso: (startMonth instanceof Date ? startMonth : new Date(startMonth)).toISOString() },
    endMonth: endMonth
      ? { __type: "Date", iso: (endMonth instanceof Date ? endMonth : new Date(endMonth)).toISOString() }
      : undefined,
    type,
  });

  const account = await accountAPI.getAccountById(accountId);
  const accountName = account?.get("name");

  if (!reportBase64String) return null;

  const dateRangeStr =
    startMonth === "lifetime"
      ? `Beginning - ${dayjs(endMonth || new Date()).format("DD MMM YYYY")}`
      : `${dayjs(startMonth).format("DD MMM YYYY")} - ${dayjs(endMonth || new Date()).format("DD MMM YYYY")}`;

  downloadReport(
    reportBase64String,
    `BK - ${accountName || "Account"} - (${dateRangeStr}).${type === "pdf" ? "pdf" : "xlsx"}`
  );

  return "success";
};

export const getFYReport = async (startMonth, endMonth, type = "pdf") => {
  const user = fetchUser();

  let fy = "";
  let startDate = undefined;
  let endDate = undefined;
  let fileName = "";

  if (startMonth === "lifetime") {
    fy = "";
    fileName = `BK - LifeTime.${type === "pdf" ? "pdf" : "xlsx"}`;
  } else if (endMonth) {
    startDate = new Date(startMonth);
    startDate.setHours(0, 0, 0, 0);

    const nextDay = new Date(endMonth);
    nextDay.setDate(nextDay.getDate() + 1);
    nextDay.setHours(0, 0, 0, 0);
    endDate = nextDay;

    fy = `${dayjs(startMonth).format("DD MMM YYYY")} - ${dayjs(endMonth).format("DD MMM YYYY")}`;
    fileName = `BK - Cashbook (${fy}).${type === "pdf" ? "pdf" : "xlsx"}`;
  } else {
    const startYear = startMonth.getFullYear();
    const endYear = startYear + 1;
    startDate = new Date(startYear, 3, 1, 0, 0, 0, 0);
    const endFYDate = new Date(endYear, 2, 31);
    const nextDay = new Date(endYear, 3, 1, 0, 0, 0, 0);
    endDate = nextDay;

    fy = `${dayjs(startDate).format("DD MMM YYYY")} - ${dayjs(endFYDate).format("DD MMM YYYY")}`;
    fileName = `BK - Cashbook (${fy}).${type === "pdf" ? "pdf" : "xlsx"}`;
  }

  const reportBase64String = await Parse.Cloud.run("getFYReport", {
    userId: user?.id,
    fy,
    type,
    ...(startDate && { startDate: { __type: "Date", iso: startDate.toISOString() } }),
    ...(endDate && { endDate: { __type: "Date", iso: endDate.toISOString() } }),
  });

  if (!reportBase64String) return null;

  downloadReport(reportBase64String, fileName);

  return "success";
};

export const downloadCollectionReport = async (accountId) => {
  // Fetch Overdue Accounts to send to the report
  // const overdueAccounts = await Parse.Cloud.run("getOverdueAccounts");
  // console.log("overdueAccounts : ",overdueAccounts);

  const overdueAccounts = await reminderAPI.getOverdueAccounts();
  console.log(overdueAccounts);
  const jsonObj = overdueAccounts.map(result => result.toJSON())
  console.log(jsonObj);

  const reportBase64String = await Parse.Cloud.run("getCollectionReport", {
    overdueAccounts: jsonObj,
  });
  downloadReport(reportBase64String, `Bahi Khata - Collection Report.pdf`);
  return "success";
};

export const getContacts = async () => {
  try {
    const query = new Parse.Query(Contacts);
    query.equalTo("userId", auth.fetchUser());
    return await query.find();
  } catch (error) {
    throw error;
  }
};
export const checkConnectivity = async () => {
  try {
    const healthResponse = await fetch(Parse.serverURL + "/health");
    if (healthResponse.ok) {
      return await healthResponse.json();
    }
  } catch (error) {
    throw new Error("Technical Error: App isn't available currently");
  }
};
